import React from 'react';
import PropTypes from 'prop-types';

import SepaRedirectPreflight from './SepaRedirectPreflight';
import PaypalRedirectPreflight from './PaypalRedirectPreflight';

const getGatewayComponent = (gatewayType) => {
    return {
        sepa: SepaRedirectPreflight,
        paypal: PaypalRedirectPreflight,
    }[gatewayType];
};

const RedirectPreflight = ({ getComponent: getOverridenComponent, gatewayType }) => {
    const Component = getOverridenComponent(gatewayType) || getGatewayComponent(gatewayType);
    return <Component />;
};

RedirectPreflight.propTypes = {
    gatewayType: PropTypes.string.isRequired,
    getComponent: PropTypes.func, // allows overriding the preflight component
};

RedirectPreflight.defaultProps = {
    getComponent: () => {},
};

export default RedirectPreflight;
